const FALLBACK_THUMBNAIL = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400';

/**
 * Format course thumbnail URL
 * Ensures base64 images have the proper data URI prefix
 * @param {string} thumbnail - Thumbnail string (base64, data URI, or URL)
 * @param {string} fallback - Fallback image URL
 * @returns {string} - Formatted thumbnail URL
 */
export const formatCourseThumbnail = (thumbnail, fallback = FALLBACK_THUMBNAIL) => {
  if (!thumbnail || thumbnail.trim() === '') {
    return fallback;
  }
  
  const trimmedThumbnail = thumbnail.trim();
  
  if (trimmedThumbnail.startsWith('data:')) return trimmedThumbnail;
  if (trimmedThumbnail.startsWith('http://') || trimmedThumbnail.startsWith('https://')) return trimmedThumbnail;
  
  if (trimmedThumbnail.includes('data:image') && trimmedThumbnail.includes('http')) {
    const urlPart = trimmedThumbnail.split(',').slice(1).join(',');
    if (urlPart.startsWith('http://') || urlPart.startsWith('https://')) return urlPart;
  }
  
  // Not a recognizable URL or data URI — return fallback instead of treating as base64
  return fallback;
};

/**
 * onError handler for thumbnail <img> tags — swaps to fallback on load failure
 */
export const handleThumbnailError = (e) => {
  if (e.target.src !== FALLBACK_THUMBNAIL) {
    e.target.src = FALLBACK_THUMBNAIL;
  }
};

